import { useMainStore } from "@/stores";
import { USER_ROLES } from "@/shared/utils/constants";

/**
 * Org admin can switch UI between admin console and member experience.
 * Backend role stays `org_admin`; this only affects nav and client-side affordances.
 */
export function useAppMode() {
  const user = useMainStore((s) => s.user);
  const appMode = useMainStore((s) => s.appMode);
  const setAppMode = useMainStore((s) => s.setAppMode);
  const toggleAppMode = useMainStore((s) => s.toggleAppMode);

  const isOrgAdmin = user?.role === USER_ROLES.ORG_ADMIN;
  const isAdminMode = isOrgAdmin && appMode === "admin";
  const isUserMode = !isOrgAdmin || appMode === "user";

  return {
    user,
    appMode,
    isAdminMode,
    isUserMode,
    isOrgAdmin,
    setAppMode,
    toggleAppMode,
  };
}
